import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserListItemsComponent } from './user-list-items.component';
import { UserProfileModule } from 'src/app/user-management/user-profile/user-profile.module';
import { DeviceStatusPipeModule } from 'src/app/libs/ui/pipes/device-status-pipe/device-status-module';
import { HideAccessModule } from 'src/app/libs/ui/directives/hide-access/hide-access.module';
import { LocalizationService } from 'src/app/shared/services/localization.service';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [UserListItemsComponent],
  imports: [CommonModule, UserProfileModule, DeviceStatusPipeModule, HideAccessModule, TranslateModule],
  exports: [UserListItemsComponent],
  providers: [
    LocalizationService,
    TranslateModule
  ],
})
export class UserListItemsModule {}
